import { flowRight } from 'lodash';
import { connect } from 'react-redux';

import withHocName from '../../app/hoc/with-hoc-name';
import withDeviceType from '../../app/hoc/with-device-type';
import {
  getLayoutName,
  getLayoutConfig,
  getPostsPerPage,
  hasPostLimit,
  getIsLayoutTextOnImage,
} from '../selectors/layout-config-selectors';
import { getPostBorderWidth } from '../selectors/app-settings-selectors';

const mapStateToProps = (state, { isMobile }) => ({
  layoutName: getLayoutName({ state, isMobile }),
  layoutConfig: getLayoutConfig({ state, isMobile }),
  isLayoutTextOnImage: getIsLayoutTextOnImage({ state, isMobile }),
  postsPerPage: getPostsPerPage(state),
  hasPostLimit: hasPostLimit(state),
  borderWidth: getIsLayoutTextOnImage({ state, isMobile }) ? 0 : isMobile ? 1 : getPostBorderWidth(state),
});

// prettier-ignore
export default flowRight(
  withDeviceType,
  connect(mapStateToProps),
  withHocName('WithLayoutProps')
);
